@let user = authService.current();

<section class="grid grid-cols-12 gap-4  p-4 lg:p-12" *transloco="let t;">
  @if (user) {
    <div class="col-span-12 relative">
      <div class="col-span-12 lg:col-span-9 flex flex-col justify-between w-full absolute">

        <div class="w-full flex justify-end">
          @if (!editing()) {
            <button wunButton primary (click)="editing.set(true)">
              {{ t('common.edit') }}
            </button>
          } @else {

            <button wunButton primary (click)="updateMe()">
              {{ t('common.save') }}
            </button>
          }

        </div>

      </div>
      <div class="text-3xl font-thin">
        {{ t('profile.welcome', {type: t('common.' + user.profileType.toLowerCase())}) }}
        {{ user.username }}
      </div>
      <div class="mt-4 grid lg:flex gap-4">
        @let media = currentMedia();
        <div class="flex flex-col gap-2">
          <div class="flex items-center justify-center overflow-hidden">
            @if (media) {
              <img [width]="media.width" [height]="media.height" [src]="media.url">
            }
            @else if (user.cover) {
              <img [width]="user.cover.width" priority [height]="user.cover.height" [ngSrc]="user.cover.url">
            } @else {
              <img [width]="300" [height]="300" ngSrc="fallback.png">
            }
          </div>
          <input type="file" accept="image/*" (change)="fileChanged(file)" #file class="hidden">

          <div class="w-full flex items-center justify-center">
            @if(!media){
              <button class="" wunButton primary (click)="file.click()">
                {{ t('common.uploadImage') }}
              </button>
            } @else {
              <button class="" wunButton primary (click)="setProfileImage()">
                {{ t('common.save') }}
              </button>
            }
          </div>

        </div>
        <form [formGroup]="updateUserForm()" class="flex flex-col gap-2 w-full">
          <div class="flex gap-4 w-full">

            @if (editing()) {
              <div class="flex flex-col justify-between pt-3 w-full">
                <div wunInputContainer>
                  <label>{{ t('common.name') }}</label>
                  <input wunInput black formControlName="name" type="text">
                </div>
                <div wunInputContainer>
                  <label>{{ t('common.surname') }}</label>
                  <input wunInput black formControlName="surname" type="text">
                </div>
                <div wunInputContainer>
                  <label>{{ t('common.nickname') }}</label>
                  <input wunInput black formControlName="nickname" type="text">
                </div>
                <div class="flex flex-col gap-1 py-2">
                  <label class="text-sm">{{ t('common.displayNamePreference') }}</label>
                  <label class="flex items-center gap-3 cursor-pointer">
                    <span class="text-sm">{{ t('common.fullNameDisplay') }}</span>
                    <div class="relative">
                      <input type="checkbox" class="sr-only peer" formControlName="useNickname">
                      <div class="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-black after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full"></div>
                    </div>
                    <span class="text-sm">{{ t('common.nickname') }}</span>
                  </label>
                </div>
                <div wunInputContainer>
                  <label>{{ t('common.country') }}</label>
                  <input wunInput black formControlName="country" type="text">
                </div>
                <div wunInputContainer>
                  <label>{{ t('common.phoneNumber') }}</label>
                  <input wunInput black formControlName="phone" type="text">
                </div>
                <div wunInputContainer>
                  <label>{{ t('common.birthDate') }}</label>
                  <input wunInput black formControlName="birthDate" type="date">
                </div>
                @if (isArtist()) {
                  <div wunInputContainer>
                    <label>{{ t('profile.galleryCode') }}</label>
                    <input wunInput black formControlName="galleryCode" type="text" autocomplete="off">
                    <span class="text-xs font-light text-gray-500">{{ t('profile.galleryCodeHint') }}</span>
                  </div>
                }
                <div>
                  <label>
                    {{ t('common.interests') }}
                  </label>
                  <wun-tag-input [(tags)]="tags" />
                </div>
              </div>
            } @else {
              <div class="pt-3">
                <div class="font-semibold">
                  @if (user.displayNamePreference === 'NICKNAME' && user.nickname) {
                    {{ user.nickname }}
                  } @else {
                    {{ user.firstName }} {{ user.lastName }}
                  }
                </div>
                <div class="flex gap-12">
                  <div class="flex flex-col justify-between w-full">
                    <div class="font-light">
                      <div>
                        {{ user.email }}
                      </div>
                      <div>
                        {{ user.country }}
                      </div>
                      <div>
                        {{ user.city }}
                      </div>
                      <div>
                        {{ t('common.tel') }} {{ user.phone || '-' }}
                      </div>
                      <div>
                        {{ user.birthday | date : 'dd/MM/yyyy' }}
                      </div>
                      @if (isArtist() && user.assignedToGallery) {
                        <div>
                          {{ t('profile.galleryCode') }}: {{ user.assignedToGallery }}
                        </div>
                      }
                    </div>
                  </div>
                  <div class="flex flex-col w-full">
                    <div>
                      {{ t('common.interests') }}
                    </div>
                    <div class="font-thin max-w-20">
                      @for (tag of tags(); track $index + '_' + tag) {
                        #{{tag}}
                      }
                    </div>
                  </div>
                  @if (false) {
                    <div class="flex flex-col w-full">
                      <div>
                        {{ t('common.iban') }}
                      </div>
                      <div class="font-thin whitespace-nowrap">
                        IT01010101001
                      </div>
                    </div>
                  }

                </div>

              </div>

            }

          </div>

          @if (!editing()) {
            <div>
              {{ t('common.description') }}:
            </div>
            <div class="font-light">
              {{ user.description }}
            </div>
          } @else {
            <div>
              <label>
                {{ t('common.description') }}:
              </label>
              <textarea wunInput formControlName="description" black></textarea>
            </div>
          }
        </form>
      </div>
    </div>

  }

</section>
